import { Translation } from "utils/context/TranslationContext";
import {
  JacketFormType,
  ProductType,
} from "utils/data/enum";

// The configured Collateral Mortgage trans code lives in the translation list under this
// type/value pair, one row per state.
export const COLLATERAL_MORTGAGE_TRANSLATION_TYPE = "PRICING_API";
export const COLLATERAL_MORTGAGE_TRANSLATION_VALUE = "CollateralMortgage";

// These rows are externally maintained config, and "Jacket" is spelled both "JACKET"
// (ProductType) and "Jacket" (ProductTypeName) in this codebase alone, so match leniently.
const matches = (a?: string, b?: string) =>
  (a ?? "").trim().toLowerCase() === (b ?? "").trim().toLowerCase();

// The Collateral Mortgage trans code configured for a state, or "" when that state has no
// enabled row. Callers must treat "" as "this state has no Collateral Mortgage trans code".
const getCollateralMortgageTransCode = (
  translations: Array<Translation> | undefined,
  stateAbbr: string | undefined
): string => {
  if (!stateAbbr) return "";

  return (
    (translations ?? []).find(
      (translation) =>
        matches(translation.source1, ProductType.Jacket) &&
        matches(translation.source2, JacketFormType.Loan) &&
        matches(translation.source3, stateAbbr) &&
        matches(translation.target1, "true")
    )?.source4 ?? ""
  );
};

// The single place that decides whether a jacket is a Collateral Mortgage. The falsy-code
// guard is what stops an unconfigured state from matching every jacket that has no trans
// code set, which a bare equality check would do.
const isCollateralMortgageTransCode = (
  transCode: string | undefined,
  collateralMortgageTransCode: string
) =>
  Boolean(collateralMortgageTransCode) &&
  transCode === collateralMortgageTransCode;

export { getCollateralMortgageTransCode, isCollateralMortgageTransCode };
